import loanStore from "./loan/store";
import salaryManagementStore from "./salaryManagement/store";
import BenefitAndDeductionStore from "./benefits-and-deduction/store";
import reportStore from "./report/store";
import paymentWallet from "./payment-wallet/store";

export default {
  namespaced: true,
  modules: {
    loan: loanStore,
    salaryManagement: salaryManagementStore,
    benefitsAndDeduction: BenefitAndDeductionStore,
    report: reportStore,
    payment: paymentWallet,
  },
};
